/* Gem Therapy editorial — quiz logic + result reveal.
   Product data is injected by the section (script type="application/json"). */

(function quiz() {
  const root = document.getElementById('gtQuiz');
  if (!root) return;

  const dataEl = document.getElementById('gtQuizProducts');
  const PRODUCTS = dataEl ? JSON.parse(dataEl.textContent || '{}') : {};

  const ARCHETYPES = {
    deepBlue:     { name: 'Deep Blue',       virtue: 'Clarity & Focus',
                    intro: 'You named a longing for quiet thinking. Deep Blue stones favor one point of light, and refuse the rest.' },
    pink:         { name: 'Purplish Pink',   virtue: 'Joy & Tenderness',
                    intro: 'You named a softer interior. Purplish Pink spinels are the small permission to feel pleased.' },
    lavender:     { name: 'Lavender',        virtue: 'Calm & Stillness',
                    intro: 'You named the long pause between breaths. Lavender spinels keep that pause company.' },
    greenishBlue: { name: 'Greenish Blue',   virtue: 'Renewal',
                    intro: 'You named a beginning. Greenish Blue spinels are the colour of leaves after rain.' },
    gray:         { name: 'Purplish Gray',   virtue: 'Grounding',
                    intro: 'You named the wish to come back home to yourself. Purplish Gray spinels are riverbed stones.' }
  };

  const QUESTIONS = [
    { prompt: 'What are you seeking right now?',
      options: [
        { text: 'A quieter, clearer mind', weights: { deepBlue: 2 } },
        { text: 'A warmer, lighter heart', weights: { pink: 2 } },
        { text: 'A way to settle in my body', weights: { gray: 1.5, lavender: 0.5 } },
        { text: 'A small fresh beginning', weights: { greenishBlue: 2 } },
        { text: 'Steadier ground beneath me', weights: { gray: 2 } }
      ] },
    { prompt: 'Which feeling would you like more of?',
      options: [
        { text: 'Focus', weights: { deepBlue: 2 } },
        { text: 'Tenderness', weights: { pink: 2 } },
        { text: 'Stillness', weights: { lavender: 2 } },
        { text: 'Renewal', weights: { greenishBlue: 2 } },
        { text: 'Steadiness', weights: { gray: 2 } }
      ] },
    { prompt: 'Pick a sky.',
      options: [
        { text: 'A clear winter night', weights: { deepBlue: 1.5, lavender: 0.5 } },
        { text: 'Dawn with cherry blossoms', weights: { pink: 1.5, lavender: 0.5 } },
        { text: 'A long lavender dusk', weights: { lavender: 2 } },
        { text: 'Wet leaves after a passing rain', weights: { greenishBlue: 2 } },
        { text: 'Stones along a riverbed at twilight', weights: { gray: 1.5, deepBlue: 0.5 } }
      ] }
  ];

  const stage = root.querySelector('#quizStage');
  const resultEl = root.querySelector('#quizResult');
  const progress = root.querySelectorAll('.quiz-progress .dot');
  const backBtn = root.querySelector('#quizBack');
  const counter = root.querySelector('#quizCounter');
  const footBar = root.querySelector('#quizFoot');
  const answers = new Array(QUESTIONS.length).fill(null);
  let stepIndex = 0;
  const stepEls = [];

  QUESTIONS.forEach((q, qi) => {
    const wrap = document.createElement('div');
    wrap.className = 'quiz-step' + (qi === 0 ? ' is-active' : '');
    wrap.innerHTML = `
      <h3>${q.prompt}</h3>
      <div class="quiz-options" role="radiogroup" aria-label="${q.prompt}"></div>
    `;
    const opts = wrap.querySelector('.quiz-options');
    q.options.forEach((opt, oi) => {
      const btn = document.createElement('button');
      btn.className = 'quiz-opt';
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.innerHTML = `<span>${opt.text}</span>`;
      btn.addEventListener('click', () => choose(qi, oi));
      opts.append(btn);
    });
    stage.append(wrap);
    stepEls.push(wrap);
  });

  function updateProgress() {
    progress.forEach((dot, i) => {
      dot.classList.remove('active', 'done');
      if (i < stepIndex) dot.classList.add('done');
      else if (i === stepIndex) dot.classList.add('active');
    });
    if (counter) counter.textContent = `Question ${Math.min(stepIndex + 1, QUESTIONS.length)} of ${QUESTIONS.length}`;
    if (backBtn) backBtn.disabled = stepIndex === 0;
  }

  function goTo(next) {
    if (next === stepIndex) return;
    stepEls[stepIndex].classList.remove('is-active');
    stepIndex = next;
    setTimeout(() => {
      stepEls[stepIndex].classList.add('is-active');
      const a = answers[stepIndex];
      stepEls[stepIndex].querySelectorAll('.quiz-opt').forEach((b, i) => {
        const on = a === i;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      updateProgress();
    }, 220);
  }

  function choose(qi, oi) {
    answers[qi] = oi;
    stepEls[qi].querySelectorAll('.quiz-opt').forEach((b, i) => {
      const on = i === oi;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    setTimeout(() => {
      if (qi < QUESTIONS.length - 1) goTo(qi + 1);
      else reveal();
    }, 480);
  }

  backBtn && backBtn.addEventListener('click', () => {
    if (stepIndex > 0) goTo(stepIndex - 1);
  });

  function score() {
    const totals = Object.fromEntries(Object.keys(ARCHETYPES).map((k) => [k, 0]));
    answers.forEach((oi, qi) => {
      if (oi == null) return;
      const w = QUESTIONS[qi].options[oi].weights;
      for (const k in w) totals[k] += w[k];
    });
    let best = null, bestScore = -Infinity;
    for (const k of Object.keys(ARCHETYPES)) {
      if (totals[k] > bestScore) { bestScore = totals[k]; best = k; }
    }
    return best;
  }

  function renderResultCard(p) {
    const img = p.image
      ? `<img src="${p.image}" alt="${p.title}" loading="lazy" />`
      : '';
    return `
      <a class="card" href="${p.url || '#'}">
        <span class="card__media">
          ${img}
          <span class="satellite" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>
          </span>
        </span>
        <div class="card__meta">
          <div class="card__row">
            <h4 class="card__title">${p.title}</h4>
            <span class="card__price">${p.price}</span>
          </div>
          <span class="card__origin">Ceylon \u00b7 Untreated \u00b7 Cert. available</span>
        </div>
      </a>
    `;
  }

  function reveal() {
    const key = score();
    const arche = ARCHETYPES[key];
    const titleEl = root.querySelector('#resultTitle');
    const introEl = root.querySelector('#resultIntro');
    const cardsEl = root.querySelector('#resultCards');
    if (titleEl) titleEl.innerHTML = `<em>${arche.name}.</em> ${arche.virtue}`;
    if (introEl) introEl.textContent = arche.intro;
    const items = (PRODUCTS[key] || []).slice(0, 3);
    if (cardsEl) cardsEl.innerHTML = items.map(renderResultCard).join('');
    if (stage) stage.style.display = 'none';
    if (footBar) footBar.style.display = 'none';
    progress.forEach((d) => { d.classList.remove('active'); d.classList.add('done'); });
    resultEl.classList.add('show');
  }

  const restart = root.querySelector('#quizRestart');
  restart && restart.addEventListener('click', () => {
    answers.fill(null);
    stepIndex = 0;
    stepEls.forEach((el, i) => {
      el.classList.toggle('is-active', i === 0);
      el.querySelectorAll('.quiz-opt').forEach((b) => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
    });
    resultEl.classList.remove('show');
    if (stage) stage.style.display = '';
    if (footBar) footBar.style.display = '';
    updateProgress();
  });

  updateProgress();
})();
